import React from 'react'
import Box from '../../../../../Global/Box'
import moment from 'moment'

const DetailsEmployeeLog = ({
  item,
  id,
  setCloseModal,
  getMinutesFunction,
}) => {
  return (
    <>
      <Box
        title=""
        withCard={false}
        content={
          <>
            <div className="row">
              <div
                className="col-lg-12"
                style={{
                  backgroundColor:
                    item.check_type === 'entrada'
                      ? '#d4edda'
                      : item.check_type === 'ausencia'
                      ? '#fff3cd'
                      : '#f8d7da',
                  borderRadius: '5px',
                  marginTop: '10px',
                  paddingTop: '10px',
                  // padding: '',
                  marginBottom: '10px',
                  maxWidth: '90%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  color:
                    item.check_type === 'entrada'
                      ? '#28a745'
                      : item.check_type === 'ausencia'
                      ? '#ffc107'
                      : '#dc3545',
                }}
              >
                <h3 className="text-center">
                  <i
                    className={`fas fa-${
                      item.check_type === 'entrada'
                        ? 'door-open'
                        : item.check_type === 'ausencia'
                        ? 'exclamation-triangle'
                        : 'door-closed'
                    } mr-2`}
                    style={{
                      color:
                        item.check_type === 'entrada'
                          ? '#28a745'
                          : item.check_type === 'ausencia'
                          ? '#ffc107'
                          : '#dc3545',
                    }}
                  ></i>
                  {item.formatted_check_type}
                  {item.EmployeeLogsToJustification ? ' - Justificada' : ''}
                </h3>
              </div>
              <div className="col-lg-4 mt-2">
                <div className="card h-100 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title text-secondary">
                      <i className="fas fa-user mr-2"></i>
                      <strong>
                        {item.check_type === 'entrada'
                          ? 'Hora de entrada'
                          : item.check_type === 'ausencia'
                          ? 'Ausencia'
                          : 'Hora de salida'}
                      </strong>
                    </h5>
                    <p className="card-text lead">
                      {item.check_type === 'ausencia'
                        ? '--:--'
                        : moment(item.check_date).format('hh:mm A')}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 mt-2">
                <div className="card h-100 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title text-secondary">
                      <i className="fas fa-user mr-2"></i>
                      <strong>
                        {item.check_type === 'entrada'
                          ? 'Retardo de entrada'
                          : 'Anticipación de salida'}
                      </strong>
                    </h5>
                    <p className="card-text lead">
                      {getMinutesFunction(
                        item.check_type === 'entrada'
                          ? item.lateness_time
                          : item.left_early_time
                      )}
                      (
                      {item.check_type === 'entrada'
                        ? moment(item.lateness_time, 'HH:mm:ss').format('HH:mm')
                        : item.check_type === 'ausencia'
                        ? '--:--'
                        : moment(item.left_early_time, 'HH:mm:ss').format(
                            'HH:mm'
                          )}
                      )
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 mt-2">
                <div className="card h-100 shadow-sm">
                  <div className="card-body">
                    <h5 className="card-title text-secondary">
                      <i className="fas fa-user mr-2"></i>
                      <strong>Estado del registro</strong>
                    </h5>
                    <p className="card-text lead">
                      {item.formatted_log_status}
                    </p>
                  </div>
                </div>
              </div>
              {item.check_type === 'ausencia' && (
                <>
                  <div className="col-lg-4 mt-2">
                    <div className="card h-100 shadow-sm">
                      <div className="card-body">
                        <h5 className="card-title text-secondary">
                          <i className="fas fa-user mr-2"></i>
                          <strong>Justificante</strong>
                        </h5>
                        <p className="card-text lead">
                          {item.EmployeeLogsToJustification
                            ? item.EmployeeLogsToJustification
                                .justification_type_spanish
                            : 'No hay justificante'}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 mt-2">
                    <div className="card h-100 shadow-sm">
                      <div className="card-body">
                        <h5 className="card-title text-secondary">
                          <i className="fas fa-user mr-2"></i>
                          <strong>Estatus Justificante</strong>
                        </h5>
                        <p className="card-text lead">
                          {item.EmployeeLogsToJustification
                            ? item.EmployeeLogsToJustification.status
                            : 'N/A'}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 mt-2">
                    <div className="card h-100 shadow-sm">
                      <div className="card-body">
                        <h5 className="card-title text-secondary">
                          <i className="fas fa-user mr-2"></i>
                          <strong>Fecha Justificante</strong>
                        </h5>
                        <p className="card-text lead">
                          {item.EmployeeLogsToJustification
                            ? moment(
                                item.EmployeeLogsToJustification
                                  .justification_date
                              ).format('DD/MM/YYYY')
                            : 'N/A'}
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 mt-2">
                    <div className="card h-100 shadow-sm">
                      <div className="card-body">
                        <h5 className="card-title text-secondary">
                          <i className="fas fa-user mr-2"></i>
                          <strong>Archivo Justificante</strong>
                        </h5>
                        <p className="card-text lead">
                          {item.EmployeeLogsToJustification ? (
                            <a
                              href={
                                item.EmployeeLogsToJustification.document_url
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Ver Justificante
                            </a>
                          ) : (
                            'N/A'
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </>
        }
      />
    </>
  )
}

export default DetailsEmployeeLog
